import React, { useState,useEffect,useRef  } from 'react';
import Slide from './components/Slide/Slide';
import CardSlide from './components/CardSlide/CardSlide';
import VideoBackground from './components/VideoBackground/VideoBackground';
import PageNavigation from './components/PageNavigation/PageNavigation';
import { Element, scroller } from 'react-scroll';
import Navbar from './components/Navbar/Navbar';
import Card from './components/Card/Card';
import Resources from './components/Resources/Resources';
import Contact from './components/Contact/Contact';
import './App.css';
import '@fortawesome/fontawesome-free/css/all.min.css';

const App = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const homeRef = useRef(null);
  const dataRef = useRef(null);
  const contactRef = useRef(null);

  const slides = [
    { component: <VideoBackground ref={homeRef}/>, darkBackground: true,id:'home',ref: homeRef},
    { component: <CardSlide ref={dataRef}/>, darkBackground: false,id:'our-data',ref: dataRef},
    { component: <Contact ref={contactRef} />, darkBackground: false,id:'contact',ref: contactRef},
  ];

  const handleKeyDown = (event) => {
    if (event.key === 'ArrowDown' && currentSlide < slides.length - 1) {
      setCurrentSlide(currentSlide + 1);
    }
  };

  const handlePageClick = (index) => {
    setCurrentSlide(index);
  };

  return (
    <div className="App" tabIndex="0" onKeyDown={handleKeyDown}>
      <Navbar darkBackground={slides[currentSlide].darkBackground}  sections={slides} />
      {/* {slides[currentSlide].component} */}
      {slides.map((slide, index) => (
          slide.component
      ))}
      {/* <Resources/> */}
      {/* <Contact/> */}
      {/* <PageNavigation
        currentSlide={currentSlide}
        totalSlides={slides.length}
        onPageClick={handlePageClick}
      /> */}
    </div>
  );
};

export default App;
